(function () {
    'use strict';

    const controlShowTelNumber = () => {
        const targets = document.getElementsByClassName("js-control-show-tel-number");
        if (!targets)
            return;
        Array.from(targets).forEach((target) => {
            target.classList.remove("is-hidden");
        });
    };
    const from = new URLSearchParams(window.location.search).get("from");
    if (from === "business-gift") {
        controlShowTelNumber();
    }

})();
